import { useState, useRef, useEffect } from 'react';
import strFunc from '@/lib/lyg/string';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import TextBookAddWordPopup from "@/pages/comp/plan/word/word_inside/popup/add_word";

function UploadWordArea(props: any) {
  let myProps = {
    list: (inData: any) => { },
    ...props
  };

  const default_popup_data = {
    isOpen: false,
    sort: "manage_textbook_sort",//view
    listOpt: {},
    g_par_id: "",
    g_par_seq: "",
    word_type: "",
    title: "팝업",
    width: "100%",
    height: "90%",
  };
  const [popupData, setPopupData] = useState({ ...default_popup_data });

  const open_add_word_popup = (inData: any) => {
    let opt_obj = {
      g_par_id: "word_inside",
      g_par_seq: "",
      word_type: "word",//stc
      ...inData
    };

    if (strFunc.is_empty(opt_obj.g_par_id)) {
      alert("분류가 선택되지 않았습니다.");
      return false;
    }
    if (strFunc.is_empty(opt_obj.word_type)) {
      alert("분류키가 선택되지 않았습니다.");
      return false;
    }

    let pop_title = "단어 추가";
    if (opt_obj.word_type === "stc") {
      pop_title = "문장 추가";
    }

    setPopupData({
      ...default_popup_data,
      isOpen: true,
      sort: "add_word",
      g_par_id: opt_obj.g_par_id,
      g_par_seq: opt_obj.g_par_seq,
      word_type: opt_obj.word_type,
      title: pop_title,
      width: "80%",
    });
  };

  return (
    <div className="w-full px-4 py-3">
      <div className="grid grid-cols-2 gap-4 max-w-4xl mx-auto">
        {/* 단어 버튼 */}
        <button className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
          onClick={() => {
            open_add_word_popup({
              word_type: "word",
            });
          }}>
          <div className="relative z-10 flex flex-col items-center justify-center py-8 px-6">
            <div className="mb-3 text-4xl">
              📚
            </div>
            <h3 className="text-2xl font-bold text-white mb-1">
              단어
            </h3>
            <p className="text-blue-100 text-sm">
              Word Upload
            </p>
          </div>
          {/* 호버 효과 */}
          <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
        </button>

        {/* 문장 버튼 */}
        <button className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
          onClick={() => {
            open_add_word_popup({
              word_type: "stc",
            });
          }}>
          <div className="relative z-10 flex flex-col items-center justify-center py-8 px-6">
            <div className="mb-3 text-4xl">
              💬
            </div>
            <h3 className="text-2xl font-bold text-white mb-1">
              문장
            </h3>
            <p className="text-purple-100 text-sm">
              Sentence Upload
            </p>
          </div>
          {/* 호버 효과 */}
          <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
        </button>
      </div>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "add_word" &&
            <TextBookAddWordPopup
              g_par_id={popupData.g_par_id}
              g_par_seq={popupData.g_par_seq}
              word_type={popupData.word_type}
              callbackData={(inData: any) => { }}
              refreshData={(inData: any) => { myProps.list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></TextBookAddWordPopup>
          }
        </LayerPopup>
      }
    </div>
  );
}
export default UploadWordArea;